import { render, staticRenderFns } from "./BatchOperations.vue?vue&type=template&id=0ec2e6fd"
import script from "./BatchOperations.vue?vue&type=script&lang=js"
export * from "./BatchOperations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports